/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { SchedulationResult } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Calcola l’hash di una sessione (richiamato B2B dallo scheduler)
 */
export const postBackRegistrazioneSessioniIdHash = (
  idRegistrazioneSessione: string,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<SchedulationResult>(
    {
      url: `/framework-bo-procedimenti/registrazione-sessioni/${idRegistrazioneSessione}/hash`,
      method: 'post',
    },
    options,
  );
};

export const getPostBackRegistrazioneSessioniIdHashMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackRegistrazioneSessioniIdHash>>,
    TError,
    { idRegistrazioneSessione: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackRegistrazioneSessioniIdHash>>,
  TError,
  { idRegistrazioneSessione: string },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackRegistrazioneSessioniIdHash>>,
    { idRegistrazioneSessione: string }
  > = props => {
    const { idRegistrazioneSessione } = props ?? {};

    return postBackRegistrazioneSessioniIdHash(
      idRegistrazioneSessione,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackRegistrazioneSessioniIdHashMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackRegistrazioneSessioniIdHash>>
>;

export type PostBackRegistrazioneSessioniIdHashMutationError =
  ErrorType<unknown>;

export const usePostBackRegistrazioneSessioniIdHash = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackRegistrazioneSessioniIdHash>>,
    TError,
    { idRegistrazioneSessione: string },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackRegistrazioneSessioniIdHashMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Riattiva la schedulazione delle registrazioni sessioni dopo riavvio (richiamato B2B dallo scheduler)
 */
export const postBackRegistrazioneSessioniRiattiva = (
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<void>(
    {
      url: `/framework-bo-procedimenti/registrazione-sessioni/riattiva`,
      method: 'post',
    },
    options,
  );
};

export const getPostBackRegistrazioneSessioniRiattivaMutationOptions = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackRegistrazioneSessioniRiattiva>>,
    TError,
    TVariables,
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postBackRegistrazioneSessioniRiattiva>>,
  TError,
  TVariables,
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postBackRegistrazioneSessioniRiattiva>>,
    TVariables
  > = () => {
    return postBackRegistrazioneSessioniRiattiva(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostBackRegistrazioneSessioniRiattivaMutationResult = NonNullable<
  Awaited<ReturnType<typeof postBackRegistrazioneSessioniRiattiva>>
>;

export type PostBackRegistrazioneSessioniRiattivaMutationError =
  ErrorType<unknown>;

export const usePostBackRegistrazioneSessioniRiattiva = <
  TError = ErrorType<unknown>,
  TVariables = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postBackRegistrazioneSessioniRiattiva>>,
    TError,
    TVariables,
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPostBackRegistrazioneSessioniRiattivaMutationOptions(options);

  return useMutation(mutationOptions);
};
